import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class Site extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/site'
    super(store, path)
  }

  clone(model, showProgress) {
    return this._request({
      action: 'instantiate',
      body: model,
      method: 'POST',
      showProgress
    })
  }
}
